<script>
    import { createEventDispatcher } from "svelte";
    export let last = false;

    const dispatch = createEventDispatcher();
</script>

<div class="dialog">
    <p class="dialog-title">Delete this comment?</p>
    <footer class="dialog-footer">
        <button
            class="dialog-btn"
            on:click={() => dispatch("deletionCanceled")}
        >
            Cancel
        </button>
        <button
            class="dialog-btn dialog-btn--red"
            on:click={() => dispatch("deletionConfirmed")}
        >
            Delete
        </button>
    </footer>
</div>

<style>
    @import "../main.css";

    .dialog {
        @apply reset absolute bottom-0 left-0 z-20 flex h-full w-full flex-col bg-pink-100 !important;
    }

    .dialog-title {
        @apply reset px-4 pt-4 text-sm !important;
    }

    .dialog-title .dialog-name {
        @apply my-2 block border-0 border-l border-solid border-pink-600 py-1 pl-2 !important;
    }

    .dialog-footer {
        @apply sticky bottom-6 mt-auto flex select-none justify-end bg-transparent px-2 pb-2 pt-1 !important;
    }

    .dialog-btn {
        @apply reset rounded-sm border-none px-2 py-1 text-xs font-normal text-black no-underline hover:bg-pink-200 focus:outline-none !important;
    }

    .dialog-btn--red {
        @apply font-bold text-pink-500 hover:bg-pink-200 !important;
    }
</style>
